import { render, staticRenderFns } from "./BenefitsList.vue?vue&type=template&id=6eef1cfa&scoped=true&"
import script from "./BenefitsList.vue?vue&type=script&lang=js&"
export * from "./BenefitsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef1cfa",
  null
  
)

export default component.exports